module.exports = new __parcel__URL__("Assassinskill_45.ab4bfe8a.png").toString();